import axios from 'axios';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { parseError } from 'utils/helpers';
import BaseCheckbox from 'components/Base/BaseCheckbox';
import PhoneInput from 'react-phone-input-2';

const TabTeamContacts = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        send_reminders: false,
    });
    const [prevFormData, setPrevFormData] = useState({
        name: '',
        email: '',
        phone: '',
        send_reminders: false,
    });

    const [isSavedField, setIsSavedField] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState({});

    useEffect(() => {
        axios.get('/profile/emergency-contact')
            .then((response) => {
                const data = {
                    name: response.data?.name || '',
                    email: response.data?.email || '',
                    phone: response.data?.phone || '',
                    send_reminders: response.data?.send_reminders || response.data?.appointmentConfirmation || false,
                };
                setFormData(data);
                setPrevFormData(data);
            })
            .catch((error) => {
                setError(parseError(error));
            });
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const compareChanges = (e) => {
        const { name, value } = e.target;
        if (prevFormData[name] === value) return;

        saveChanges(name, value);
    };

    const comparePhoneNumber = (e) => {
        if (prevFormData.phone === e.target.value) return;
        saveChanges("phone", e.target.value.replace(/\D/g, ''));
    }

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        setFormData(prev => ({ ...prev, send_reminders: checked }));

        if (prevFormData.send_reminders !== checked) {
            saveChanges('send_reminders', checked);
        }
    };

    const saveChanges = (name, value) => {
        setError({});
        setIsLoading(true);
        const previousValue = prevFormData[name];

        const dbField = name === 'send_reminders'
            ? 'emergencyContact.appointmentConfirmation'
            : `emergencyContact.${name}`;

        axios
            .patch('/profile/general', { field: dbField, value: value })
            .then(() => {

                setPrevFormData(prev => ({ ...prev, [name]: value }));


                setIsSavedField({ [name]: true });
                setTimeout(() => {
                    setIsSavedField({});
                }, 900);
            })
            .catch((error) => {

                setError(parseError(error));
                setFormData(prev => ({ ...prev, [name]: previousValue }));
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div className="edit-tab team-contacts">
            {error.message && (
                <div className="error mb-4">
                    <b>{error.type}:</b> {error.message}
                </div>
            )}

            <div className="input-container relative">
                <div className="base-label">Caregiver Name</div>
                <input
                    type="text"
                    name="name"
                    className={classNames('base-input', { save: isSavedField['name'] })}
                    value={formData.name}
                    onChange={handleChange}
                    onBlur={compareChanges}
                    placeholder="John Doe"
                    disabled={isLoading && isSavedField['name']}
                />
                <span className={classNames("saved-message", { show: isSavedField['name'] })}>
                    Saved
                </span>
            </div>

            <div className="input-container relative">
                <div className="base-label">Email</div>
                <input
                    type="text"
                    name="email"
                    className={classNames('base-input', { save: isSavedField['email'] })}
                    value={formData.email}
                    onChange={handleChange}
                    onBlur={compareChanges}
                    placeholder="email@example.com"
                />
                <span className={classNames("saved-message", { show: isSavedField['email'] })}>
                    Saved
                </span>
            </div>

            <div className="input-container relative">
                <div className="base-label">Caregiver Phone</div>

                <PhoneInput
                    className={classNames('phone-input', { save: isSavedField.phone })}
                    country={'us'}
                    name="phone"
                    specialLabel=''
                    value={formData.phone?.toString()}
                    onChange={(phone) => setFormData(prevForm => ({ ...prevForm, phone: phone }))}
                    onBlur={comparePhoneNumber}
                />

                <span className={classNames("saved-message", { show: isSavedField['phone'] })}>
                    Saved
                </span>
            </div>

            <div className="input-container relative">
                <label className="checkbox-wrapper base-label" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <BaseCheckbox
                        onChange={handleCheckboxChange}
                        checked={formData.send_reminders}
                    />
                    <span style={{ marginBottom: 0, cursor: 'pointer', marginLeft: '10px' }}>
                        Send appointment confirmations and reminders to this person.
                    </span>
                </label>
                <span
                    className={classNames("saved-message", { show: isSavedField['send_reminders'] })}
                >
                    Saved
                </span>
            </div>
        </div>
    );
};

export default TabTeamContacts;